import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/issueFlightTicket', request)
}

export {post}
